import { NgIf } from "@angular/common";
import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { FormControl, ReactiveFormsModule } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ModalComponent } from "../../../components/layout/modal/modal.component";
import { InjectHTMLDirective } from "../../../directives/inject-html.directive";
import { ButtonComponent } from "../button/button.component";
import { ValidatorComponent } from "../validator/validator.component";

@Component({
  selector: "app-radio",
  templateUrl: "./radio.component.html",
  styleUrls: ["./radio.component.scss"],
  standalone: true,
  imports: [
    NgIf,
    ReactiveFormsModule,
    InjectHTMLDirective,
    ValidatorComponent,
    ButtonComponent,
    ModalComponent,
  ],
})
export class RadioComponent implements OnInit {
  @Input() label: string = "";
  @Input() value: string = "";
  @Input() id: string = ""; //invullen om de klik op de label te doen werken.
  @Input() name: string = "";
  @Input() control!: FormControl;
  @Input() type: "radio" | "checkbox" | "switch" | string = "radio";
  @Input() labelTop: boolean = false;
  @Input() modal: boolean = false;
  @Input() modalTitle: string = "Meer info";

  @Input() showValidator = true;

  @ViewChild("content") content!: ElementRef;

  constructor(private modalService: NgbModal) {}

  ngOnInit(): void {
    //als er geen id is ingevuld dan random id genereren
    if (!this.id || this.id.length === 0) {
      this.id = "radio-" + Math.random().toString(36).substring(2, 15);
    }
  }

  open(content: any) {
    this.modalService.open(content, {
      ariaLabelledBy: "modal-basic-title",
      centered: true,
      size: "lg",
    });
  }
}
